import * as s from "./LoginStyled";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import {
  LoginInfo,
  LOGIN_STEP,
  LOGIN_TAB,
} from "./LoginContainer";
import { Dispatch, SetStateAction } from "react";
import Spin from "antd/lib/spin";
import logo from "assets/images/bi_text.png";
import { useNoticeHeight } from "components/NoticePovider";
import {
  GetLoginResponse,
  PostLoginResponse,
} from "api/interfaces/authInterface.interface";
import CloudLogin from "./cloud/CloudLogin";
import ForgotPasswordSent from "./forgot/ForgotPasswordSent";
import ForgotEmail from "./forgot/email";
import LoginEmailPage from "./mydw";
import LoginTab from "./common/LoginTab";
import LoginCopy from "./common/LoginCopy";
import ResellerInfo from "./common/ResellerInfo";
import { useIsMobile } from "components/MediaQuery";
import { GoSidebarCollapse, GoSidebarExpand } from "react-icons/go";

interface Props {
  step: LOGIN_STEP;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeStep: (step: LOGIN_STEP) => void;
  cloudLoading: boolean;
  loginInfo: LoginInfo;
  setLoginInfo: Dispatch<SetStateAction<LoginInfo>>;
  setIsValidated: Dispatch<SetStateAction<Validate>>;
  setValidateMsg: Dispatch<SetStateAction<ValidateMsg>>;
  setCloudLoading: Dispatch<SetStateAction<boolean>>;
  onLoginSuccess: (data: GetLoginResponse | PostLoginResponse) => void;
  isPasskeyEnabled: boolean;
  loginTab: LOGIN_TAB;
  hideOffer: boolean;
  onChangeOfferDisplay: () => void;
}

export function LoginPresenter(props: Props): JSX.Element {
  const {
    step,
    isValidated,
    validateMsg,
    onChangeStep,
    cloudLoading,
    loginInfo,
    setIsValidated,
    setValidateMsg,
    setCloudLoading,
    onLoginSuccess,
    isPasskeyEnabled,
    loginTab,
    setLoginInfo,
    hideOffer,
    onChangeOfferDisplay,
  } = props;

  const { noticeHeight } = useNoticeHeight();
  const isMobile = useIsMobile();

  return (
    <Spin
      spinning={cloudLoading}
      size="large"
      indicator={
        <div className="progress-indicator progress-indicator--responsive" />
      }
    >
      <s.BG noticeHeight={noticeHeight}>
        <s.LoginContainer
          $hideOffer={hideOffer || step === LOGIN_STEP.RESELLER}
        >
          <s.LoginForm
            className={step === LOGIN_STEP.RESELLER ? "reseller-form" : ""}
            $hideOffer={hideOffer || step === LOGIN_STEP.RESELLER}
          >
            {step !== LOGIN_STEP.RESELLER && (
              <>
                <s.LoginLogo>
                  <img src={logo} alt="myDW Cloud Services" />
                </s.LoginLogo>
                <s.LoginFormTitle>Sign In to Your Account</s.LoginFormTitle>
                <LoginTab
                  loginTab={loginTab}
                  onChangeStep={onChangeStep}
                  isPasskeyEnabled={isPasskeyEnabled}
                />
              </>
            )}

            <s.LoginInner
              className={
                step === LOGIN_STEP.RESELLER ? "reseller-form-inner" : ""
              }
            >
              {(step === LOGIN_STEP.INPUT_EMAIL ||
                step === LOGIN_STEP.INPUT_PASSWORD ||
                step === LOGIN_STEP.LOGIN_WITH_PASSKEY ||
                step === LOGIN_STEP.SETUP_PASSKEY ||
                step === LOGIN_STEP.RESELLER) && (
                <LoginEmailPage
                  loginInfo={loginInfo}
                  setLoginInfo={setLoginInfo}
                  isValidated={isValidated}
                  setIsValidated={setIsValidated}
                  validateMsg={validateMsg}
                  setValidateMsg={setValidateMsg}
                  step={step}
                  onChangeStep={onChangeStep}
                  onLoginSuccess={onLoginSuccess}
                />
              )}

              {(step === LOGIN_STEP.FORGOT_EMAIL ||
                step === LOGIN_STEP.FORGOT_EMAIL_SENT) && (
                <ForgotEmail
                  isValidated={isValidated}
                  validateMsg={validateMsg}
                  onChangeStep={onChangeStep}
                  setLoginInfo={setLoginInfo}
                  setIsValidated={setIsValidated}
                  setValidateMsg={setValidateMsg}
                  step={step}
                  loginInfo={loginInfo}
                />
              )}

              {step === LOGIN_STEP.FORGOT_PASSWORD && (
                <ForgotPasswordSent
                  loginInfo={loginInfo}
                  onChangeStep={onChangeStep}
                />
              )}

              {step === LOGIN_STEP.DW_CLOUD && (
                <CloudLogin
                  validateMsg={validateMsg}
                  setValidateMsg={setValidateMsg}
                  isValidated={isValidated}
                  setIsValidated={setIsValidated}
                  onLoginSuccess={onLoginSuccess}
                  setCloudLoading={setCloudLoading}
                />
              )}
            </s.LoginInner>
            {(step === LOGIN_STEP.INPUT_EMAIL || !isMobile) &&
              step !== LOGIN_STEP.RESELLER && (
                <s.HideOfferButton
                  onClick={onChangeOfferDisplay}
                  $step={step}
                  $hideOffer={hideOffer}
                  data-testid="auth-signin-signin-hide-offer-button-change-offer-display"
                >
                  <span>
                    {hideOffer ? <GoSidebarExpand /> : <GoSidebarCollapse />}
                  </span>
                  {hideOffer ? "Show Offer" : "Hide Offer"}
                </s.HideOfferButton>
              )}
          </s.LoginForm>
          {step !== LOGIN_STEP.RESELLER &&
            !hideOffer &&
            (!isMobile || (isMobile && step === LOGIN_STEP.INPUT_EMAIL)) && (
              <ResellerInfo onChangeStep={onChangeStep} />
            )}
        </s.LoginContainer>
        <s.Version>v{process.env.REACT_APP_VERSION}</s.Version>
      </s.BG>
    </Spin>
  );
}
